<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><em>Dedicated to all my teachers —</em></p>
<p class="center">Those who gave me many years of guidance<br/>And those who offered transforming moments of inspiration</p>
<p class="center">In gratitude for the great blessings of the Dharma</p>
<p class="center">Lord Buddha Shakyamuni, Guru Rinpoche,<br/>Anagarika Sri Munindra, Sri S. N. Goenka,<br/>Mrs. Nani Bala Barua (Dipa Ma), Joshu Sasaki Roshi,<br/>His Holiness the Dalai Lama, the Venerable Mahasi Sayadaw,<br/>the Venerable Sayadaw U Pandita,<br/>His Holiness the Sixteenth Karmapa,<br/>Dilgo Khyentse Rinpoche,<br/>Tulku Urgyen Rinpoche, Nyoshul Khen Rinpoche,<br/>and Tsoknyi Rinpoche</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062026361_epub_ded_r1.vue?18a656b6